import getHypertune from './getHypertune'
import { getAnonymousId, setAnonymousIdIfNeeded } from './anonymousId'

const hypertuneLib = {
  getHypertune,
  getAnonymousId,
  setAnonymousIdIfNeeded
}

export default hypertuneLib
